import { Fragment, useState } from 'react';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import { Avatar, Skeleton } from '@material-ui/core';
import 'react-image-crop/dist/ReactCrop.css';
import { userAtom } from 'src/atoms/user';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMutation } from 'react-query';
import { uploadImage } from 'src/services/images.services';
import { snackbarAtom } from 'src/atoms/snackbar';
import UploadImageDialog from './UploadImageDialog';
import { useParams } from 'react-router';
import { queryClient } from 'src';

const ProfilePic = ({ employee, src, loading, refetch }) => {
  const { id } = useParams();
  const user = useRecoilValue(userAtom);
  const [open, setOpen] = useState(false);

  const [, setSnackbar] = useRecoilState(snackbarAtom);

  const { mutate, isLoading: uploadImageLoading } = useMutation(
    async (formData) =>
      await uploadImage(`/employees/${employee ? id : user.id}/profile_picture`, formData),
    {
      onSuccess: async (data) => {
        if (!employee) {
          refetch(data.profile_picture);
        } else {
          queryClient.invalidateQueries(['user_profile', id]);
        }
        setOpen(false);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || 'Something went wrong',
          severity: 'error'
        });
      }
    }
  );

  const handleUploadImage = async (image) => {
    if (!image) return;
    const formData = new FormData();
    formData.append('profile_picture', image);
    mutate(formData);
  };
  return (
    <Fragment>
      <UploadImageDialog
        open={open}
        handleClose={() => setOpen(false)}
        handleUploadImage={handleUploadImage}
        loading={uploadImageLoading}
        src={src}
      />
      {loading || uploadImageLoading ? (
        <Skeleton variant="circular" width={150} height={150} style={{ margin: 'auto' }} />
      ) : (
        <Avatar
          src={src}
          alt="photoURL"
          variant="circular"
          style={{ width: '150px', height: '150px' }}
        />
      )}

      <div
        style={{
          position: 'absolute',
          bottom: '0px',
          right: '0px',
          cursor: 'pointer',
          zIndex: 100,
          background: 'white',
          borderRadius: '100%',
          aspectRatio: '1/1',
          width: '40px',
          height: '40px',
          padding: '10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)'
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <EditRoundedIcon color="textSecondary" />
      </div>
    </Fragment>
  );
};

export default ProfilePic;
